import React from "react";
import { useSelector } from "react-redux";
import { Box } from "@mui/material";

import { getPlayerState } from "../../../redux/features/playerSlice";
import UseWindowDimensions from "../../../utils/windowSize";
import Category from "./Category";
import SearchField from "./SearchField";
import Table from "./Table";
import { getSettingState } from "../../../redux/features/settingSlice";
import CustomHelmet from "../CustomHelmet";

const ExplorePage = () => {
  const { searchExplore, categoryExplor } = useSelector(getSettingState);
  const { minimizePlayer } = useSelector(getPlayerState);
  const { height } = UseWindowDimensions();

  const helmetTitle = () => {
    var title;
    if (searchExplore) {
      title = searchExplore;
    }
    if (categoryExplor) {
      title = categoryExplor?.name;
    }
    if (!searchExplore && !categoryExplor) {
      title = "Category list";
    }
    return title;
  };

  return (
    <>
      <CustomHelmet title={`${helmetTitle()} | Explore`} />

      <Box
        sx={{
          backgroundColor: "white.main",
          height: height - 61 - (minimizePlayer ? 82 : 0) + "px",
          overflowY: "auto",
          overflowX: "hidden",
        }}
      >
        <SearchField />
        {searchExplore === "" && !categoryExplor ? (
          <Box sx={{ padding: "0px 16px 18px 16px" }}>
            <Category />
          </Box>
        ) : (
          <Table type='explore' />
        )}
      </Box>
    </>
  );
};
export default ExplorePage;
